import { ApolloClient, HttpLink, InMemoryCache } from "@apollo/client"

// Rails' CSRF token, rendered into the SPA shell by SpaController.
function csrfToken(): string {
  return document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]')?.content ?? ""
}

export const client = new ApolloClient({
  link: new HttpLink({
    uri: "/graphql",
    credentials: "same-origin",
    headers: { "X-CSRF-Token": csrfToken() },
  }),
  cache: new InMemoryCache(),
})
